import store from '@/store'
import User from '@model/User.js'

export function _resolvePatientJourneyListColumnOfType_ptVirtualUser(column, patientJourney, row, errors, isGoddard) {
    if (isGoddard && row[column.id]) {
        const userData = row[column.id]

        if (userData.titledFullName) {
            column.cellText = userData.titledFullName
        } else {
            // todo: remove this else block when MSK-16432 is complete
            const user = new User(userData)
            if (user?.titledFullName) {
                column.cellText = user.titledFullName
            }
        }
    }

    if (row.ptVirtualClinicianId) {
        const user = store.state.user.users[row.ptVirtualClinicianId]

        if (user) {
            column.ptVirtualUser = user
            column.cellText = user.titledFullName
        }
    }
}
